import React, { useState, useEffect } from "react";
import { Col, Row, Toast, Alert, Button } from "react-bootstrap";
import { FaRegListAlt, FaQuestionCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

import RecentJobsList from "../../../Components/RecentJobsList";
import MessagesList from "../../../Components/MessagesList";

import NewJobList from "../../../Components/NewJobsList";
import { getRecentMessagesForJobSeeker } from "../../../Services/MessagesService";
//import getJobsList from "../../../Services/JobsServices";
import AllActivities from "../../../Components/AllActivities";
//import getJobsPostingList from "../../../Services/JobsPostingServices";
import getAllActivities from "../../../Services/AllActivities";
import {
  recentActivityPerPage,
  recentMessagesPerPage,
  recentJobsPerPage,
} from "../../../Utilities/Helper";
import { toast } from "react-toastify";
import { getAllJobs, getDashboardJobs } from "../../../Services/AllJobsService";
import { get } from "../../../Services/AxiosService";
import { getUserDetailsAPI } from "../../../Utilities/APIHelper";
import TermsReacceptanceModal from "../../../Components/Shared/TermsReacceptanceModal";
import { useTermsAcceptance } from "../../../hooks/useTermsAcceptance";

export default function Dashboard() {
  const [RecentActivities, setActivities] = useState([]);
  const [Messages, setMessages] = useState([]);
  const [NewJobs, setNewJobs] = useState([]);

  //getting recent activity jobs list
  const [showSpinnerForActivities, setShowSpineerForActivities] =
    useState(true);
  const [showSpinnerForMessages, setShowSpineerForMessages] = useState(true);
  const [showSpinnerForJobs, setShowSpinnerForJobs] = useState(true);
  const [refreshJob, setRefreshJob] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [showHelp, setShowHelp] = useState(false);

  // Terms acceptance functionality
  const {
    showTermsModal,
    termsAccepted,
    acceptTerms,
    declineTerms,
    openTermsInNewWindow,
    currentTermsVersion,
  } = useTermsAcceptance(email);

  useEffect(() => {
    async function activitiesData() {
      getAllActivities("recordperpage=" + recentActivityPerPage)
        .then((res) => {
          const result = JSON.parse(res.response);
          const data = result.userActivity;
          setActivities(data);
          setShowSpineerForActivities(false);
        })
        .catch((err) => {
          console.log("Activity: ", err);
          setShowSpineerForActivities(false);
        });
    }
    activitiesData();
  }, []);

  // getting jobs posting list
  useEffect(() => {
    async function jobsData() {
      getDashboardJobs(`recordperpage=${recentJobsPerPage}`)
        .then((res) => {
          const result = JSON.parse(res.response);
          setNewJobs(result.jobs);
          setShowSpinnerForJobs(false);
        })
        .catch((err) => {
          setShowSpinnerForJobs(false);
          console.log("Jobs: ", err);
        });
    }
    jobsData();
  }, [refreshJob]);

  // getting Messages list
  useEffect(() => {
    async function messagesData() {
      getRecentMessagesForJobSeeker("?recordperpage=" + recentMessagesPerPage)
        .then((res) => {
          //console.log(res);
          const result = JSON.parse(res.response);
          var resultArray = [];
          result.forEach((element) => {
            var obj = {};
            obj.name = element.fullName;
            obj.text = element.message;
            obj.date = element.createdDate;
            obj.profilePhoto = element.profilePhoto;
            resultArray.push(obj);
          });
          setMessages(resultArray);
          setShowSpineerForMessages(false);
        })
        .catch((err) => {
          setShowSpineerForMessages(false);
          console.log("Message: ", err);
        });
    }
    messagesData();
  }, []);

  useEffect(() => {
    async function getName() {
      get(getUserDetailsAPI)
        .then((res) => {
          // console.log(res.data.response);
          let response = res.data.response;
          setName(response.firstName);
          setEmail(response.email);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    getName();
  }, []);

  const refreshJobHandler = () => {
    setRefreshJob((prev) => !prev);
    setShowSpinnerForJobs(true);
  };

  return (
    <div className="container p-0">
      <TermsReacceptanceModal
        show={showTermsModal}
        onAccept={acceptTerms}
        onDecline={declineTerms}
        onOpenTerms={openTermsInNewWindow}
        currentVersion={currentTermsVersion}
      />
      <h1 className="page-title">
        Hello {name}
        <Button
          variant="link"
          className="p-0 ml-3 d-inline-flex align-items-center"
          onClick={() => setShowHelp(!showHelp)}
          title="Welcome Information"
        >
          <FaQuestionCircle size={24} className="text-info" />
          <span className="text-info ml-2" style={{ fontSize: '1rem', fontWeight: 'normal' }}>Help</span>
        </Button>
      </h1>

      {/* Show welcome message when no activities, messages, or jobs exist and loading is complete OR when help button is clicked */}
      {((RecentActivities.length === 0 &&
        Messages.length === 0 &&
        NewJobs.length === 0 &&
        !showSpinnerForActivities &&
        !showSpinnerForMessages &&
        !showSpinnerForJobs) ||
        showHelp) && (
          <Alert
            variant="info"
            className="my-4"
            dismissible={showHelp}
            onClose={() => setShowHelp(false)}
          >
            <Alert.Heading>Welcome to JobInfoNetwork!</Alert.Heading>
            <p>
              Get started with these simple steps:
            </p>
            <h5>Step 1: Create Your Resume</h5>
            <p>
              Choose “My Resume”. Create a “Private” resume to send to job postings. If you also create a “Public” resume, it will be sent to all employers that have requested resumes in your industry.
            </p>
            <h5>Step 2: Acquire a “Sponsor”</h5>
            <p>
              Job seekers with a sponsor (please see Sponsorships tab {">"} Help) are able to Network (Network {">"} Help) with employed members of the Group. A sponsored job seeker can also submit resumes (no images, please) in .doc and PDF format, as opposed to JobInfoNetwork (JIN) format only.
            </p>
            <h5>Step 3: Network with employed members of your Group in your</h5>
            <p>
              Connect with Support Team Members (employed members) in your Group and your industry who can provide valuable ideas, tips, and contacts. These employed members have volunteered to assist job seekers like yourself. Send them your resume and they will be requested to provide their best advice or connections.
            </p>
            <h5>Step 4: Search and Apply for Jobs</h5>
            <p className="mb-0">
              Browse available job postings in the "Jobs" section and apply to positions that match your skills and career goals. Use the search and filter options to find jobs in your preferred industry, location, and experience level. Stay active by checking your messages regularly for responses from employers and Support Team Members.
            </p>
          </Alert>
        )}
      <div className="dashboard-wrapper">
        <Row>
          <Col md={7}>
            <div className="dashboard-box activity dashboard-col-bg">
              <h2 className="page-sub-title">Recent Activity</h2>
              <AllActivities
                activities={RecentActivities}
                showSpinner={showSpinnerForActivities}
              />
              <Link
                className="btn btn-warning btn-xs white mt-3"
                to={`${process.env.PUBLIC_URL}/jobseeker/activitieslist`}
              >
                <FaRegListAlt className="mr-2" /> View more
              </Link>
            </div>
            <div className="dashboard-box activity dashboard-col-bg mt-5">
              <h2 className="page-sub-title">Messages</h2>
              <MessagesList
                messages={Messages}
                showSpinner={showSpinnerForMessages}
              />
              <Link
                to={`${process.env.PUBLIC_URL}/jobseeker/messages`}
                className="btn btn-warning btn-xs white mt-3"
              >
                <FaRegListAlt className="mr-2" /> View all messages
              </Link>
            </div>
          </Col>
          <Col md={5}>
            <div className="dashboard-box resume dashboard-col-bg">
              <h2 className="page-sub-title">New Job Posting</h2>
              <NewJobList
                posts={NewJobs}
                showSpinner={showSpinnerForJobs}
                refreshJobs={refreshJobHandler}
              />
              <Link
                to={`${process.env.PUBLIC_URL}/jobseeker/jobs`}
                className="btn btn-warning btn-xs white mt-3"
              >
                <FaRegListAlt className="mr-2" /> View all jobs
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

// export default Dashboard;
